import React__default from 'react';
import Columns from '../Columns/index.js';
import PostPreview from '../PostPreview/index.js';
import VariableContent from '../VariableContent/index.js';
import Typography from '../Typography/index.js';
import { VerticalColumns } from './Resources.styles.js';

var Resources = function Resources(_ref) {
  var _top$posts, _top$posts2, _left$posts, _left$posts2, _right$posts, _right$posts2;
  var top = _ref.top,
    left = _ref.left,
    right = _ref.right;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (top === null || top === void 0 || (_top$posts = top.posts) === null || _top$posts === void 0 ? void 0 : _top$posts.length) > 0 && /*#__PURE__*/React__default.createElement(VariableContent, {
    bottomPadding: "Medium"
  }, (top === null || top === void 0 ? void 0 : top.title) && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h2"
  }, top === null || top === void 0 ? void 0 : top.title), /*#__PURE__*/React__default.createElement(Columns, {
    stacked: false
  }, top === null || top === void 0 || (_top$posts2 = top.posts) === null || _top$posts2 === void 0 ? void 0 : _top$posts2.map(function (post) {
    return /*#__PURE__*/React__default.createElement(PostPreview, {
      stacked: true,
      image: post === null || post === void 0 ? void 0 : post.thumbnail,
      authorName: post === null || post === void 0 ? void 0 : post.author,
      title: post === null || post === void 0 ? void 0 : post.title,
      date: post === null || post === void 0 ? void 0 : post.date,
      link: post === null || post === void 0 ? void 0 : post.link
    });
  }))), /*#__PURE__*/React__default.createElement(VerticalColumns, null, (left === null || left === void 0 || (_left$posts = left.posts) === null || _left$posts === void 0 ? void 0 : _left$posts.length) > 0 && /*#__PURE__*/React__default.createElement(VariableContent, {
    topPadding: "Medium"
  }, /*#__PURE__*/React__default.createElement("div", null, (left === null || left === void 0 ? void 0 : left.title) && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h2",
    className: "heading-with-divider"
  }, left === null || left === void 0 ? void 0 : left.title), /*#__PURE__*/React__default.createElement(Columns, {
    stacked: true,
    className: "left-posts"
  }, (_left$posts2 = left.posts) === null || _left$posts2 === void 0 ? void 0 : _left$posts2.map(function (post) {
    return /*#__PURE__*/React__default.createElement(PostPreview, {
      image: post === null || post === void 0 ? void 0 : post.thumbnail,
      authorName: post === null || post === void 0 ? void 0 : post.author,
      title: post === null || post === void 0 ? void 0 : post.title,
      date: post === null || post === void 0 ? void 0 : post.date,
      link: post === null || post === void 0 ? void 0 : post.link,
      halfWidthImage: true
    });
  }))), (right === null || right === void 0 || (_right$posts = right.posts) === null || _right$posts === void 0 ? void 0 : _right$posts.length) > 0 && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h2",
    className: "heading-with-divider"
  }, right === null || right === void 0 ? void 0 : right.title), /*#__PURE__*/React__default.createElement(Columns, {
    stacked: true,
    className: "right-posts"
  }, (_right$posts2 = right.posts) === null || _right$posts2 === void 0 ? void 0 : _right$posts2.map(function (post) {
    return /*#__PURE__*/React__default.createElement(PostPreview, {
      stacked: true,
      authorName: post === null || post === void 0 ? void 0 : post.author,
      title: post === null || post === void 0 ? void 0 : post.title,
      date: post === null || post === void 0 ? void 0 : post.date,
      link: post === null || post === void 0 ? void 0 : post.link
    });
  }))))));
};
var Resources$1 = Resources;

export { Resources$1 as default };
//# sourceMappingURL=index.js.map
